import { Button, Dropdown } from "antd";
import React from "react";
import { HiOutlineDotsVertical } from "react-icons/hi";

export default function CustomerActions({ actions }) {
  return (
    <Dropdown
      menu={{
        items: actions,
      }}
      placement="topRight"
      arrow
    >
      <Button icon={<HiOutlineDotsVertical />} />
    </Dropdown>
  );
}
